import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { sxCircularProgressCenter, sxDarkGreyBody } from "../../../../../assets/styles/CommonSxProps";
import ModalFeedBack from "../../../../../components/ModalFeedBack";
import { DadosFamiliaUsrSPM } from "../../../../../interfaces/entities/Cancelamento/PassoSelecioneBeneficiarios/DadosFamiliaUserSPM";
import { PassoSelecioneBeneficiarios } from "../../../../../interfaces/entities/Cancelamento/PassoSelecioneBeneficiarios/PassoSelecioneBeneficiarios";
import { StepBeneficiariosProps } from "../../../../../interfaces/props/Cancelamento/StepBeneficiariosProps";
import { passoSelecioneBeneficiario } from "../../../../../services/ContratoService";
import { sxButton } from "../sxProps";
import BenefsToCancelTable from "./BenefsToCancelTable";
import { useAccessibility } from "../../../../../Store/contexts/AccessibilityContext";

const StepBeneficiarios: React.FC<StepBeneficiariosProps> = ({
  indProdutoCoop, tipoCancelamento, motivoCancelamento, onProceed, backStep, handlebenefsToCancel
}) => {

  const [loading, setLoading] = useState<boolean>(false);
  const [beneficiariosCancelamento, setBeneficiariosCancelamento] = useState<PassoSelecioneBeneficiarios>();
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);
  const someBenefChecked = beneficiariosCancelamento?.lstDadosFamiliaUsrSPM.some((benef) => (benef.checked));

  const accessibility = useAccessibility();

  useEffect(() => {
    fetchBeneficiariosCancelamento();
  }, []);

  const openModalError = (title: string, subtitle: string) => {
    setModalFeedback({
      icon: 'error',
      title: title,
      subTitle: subtitle,
      textButton: 'Fechar',
      showButtonModal: true,
      closeAction: () => setModalFeedback(null),
      buttonAction: () => setModalFeedback(null)
    });
  }

  const handleProceed = () => {
    const checkedBenefs = beneficiariosCancelamento?.lstDadosFamiliaUsrSPM.filter((benef) => benef.checked);
    const contractsWillBeCanceled = checkedBenefs?.map((listaDados) => (listaDados.contrato));
    onProceed(contractsWillBeCanceled || [], beneficiariosCancelamento!.indCancelContr);
  }

  const fetchBeneficiariosCancelamento = async () => {
    setLoading(true);
    const response = await passoSelecioneBeneficiario(indProdutoCoop, tipoCancelamento, motivoCancelamento);
    if (response?.status === 200) {
      setBeneficiariosCancelamento(response.data);
      const checkedBenefs = response.data.lstDadosFamiliaUsrSPM.filter((benef: any) => benef.checked);
      const contractsWillBeCanceled = checkedBenefs?.map((listaDados: any) => (listaDados.contrato));
      handlebenefsToCancel(contractsWillBeCanceled)
    } else {
      const errorMessage = !!response?.data.mensagem ? response.data.mensagem : 'Tente novamente em instantes';
      openModalError('Erro', errorMessage);
      console.error(response);
    }
    setLoading(false);
  }

  const handleChangeBenef = (index: number, benef: DadosFamiliaUsrSPM) => {
    const updatedList = [...beneficiariosCancelamento?.lstDadosFamiliaUsrSPM || []];
    updatedList.splice(index, 1, benef);
    const updatedBenefsCancelamento: PassoSelecioneBeneficiarios = {
      isPermissao: beneficiariosCancelamento!.isPermissao,
      indCancelContr: beneficiariosCancelamento!.indCancelContr,
      infoDivorcio: beneficiariosCancelamento!.infoDivorcio,
      msgCoopSelecBenef: beneficiariosCancelamento!.msgCoopSelecBenef,
      lstDadosFamiliaUsrSPM: updatedList,
      validationError: beneficiariosCancelamento!.validationError
    }
    setBeneficiariosCancelamento(updatedBenefsCancelamento);
  }

  return (
    <>
      <div className="motivo-cancelamento-container">
        <div>
          <Typography style={accessibility.textStyleAccessibility} sx={sxDarkGreyBody} maxWidth={'620px'}>
          Selecione abaixo o(s) beneficiário(s) para exclusão do contrato.
          </Typography>
        </div>
        {loading ? <CircularProgress sx={sxCircularProgressCenter} /> :
          <BenefsToCancelTable data={beneficiariosCancelamento} onBenefChange={handleChangeBenef} />
        }
        <div className='cancellation-buttons-container'>
          <Button
            variant="contained"
            size="large"
            onClick={handleProceed}
            disabled={!someBenefChecked}
            sx={sxButton}
            style={accessibility.buttonStyleAccessibility}
          >
            <Typography style={accessibility.buttonTextStyleAccessibility}>PROSSEGUIR</Typography>
          </Button>
          <button style={{...accessibility.textStyleAccessibility }} className="back-button" onClick={backStep} aria-label="Voltar para motivo do cancelamento">
            <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faChevronLeft} />&nbsp;&nbsp;<u>Voltar</u>
          </button>
        </div>
      </div>
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
      />
    </>
  )
}

export default StepBeneficiarios;